window.BOLD = window.BOLD || {};
window.BOLD.subscriptions = window.BOLD.subscriptions || {};
window.BOLD.subscriptions.config = window.BOLD.subscriptions.config || {};
window.BOLD.subscriptions.config.internationalization = {
  en: {
    translation: {

      cancelPanelTitle:
        "Abo kündigen",
      cancelPanelAlertMessage:
        "Wenn du dein Abo kündigst, erhältst du keine weiteren Lieferungen von \"{{subscriptionTitle}}\".",
      cancelPanelMinOrderNotMetMessage:
        "Du hast bisher {{numSubscriptionOrders}} Bestellung(en). Es fehlen noch {{remainingOrders}} Bestellung(en), um die Mindestlaufzeit zu erreichen – danach kannst du jederzeit kündigen.",
      cancelPanelCancelSubscriptionFlowCancelSubscriptionConfirmationButton:
        "Ja, Abo kündigen",
      cancelPanelCancelSubscriptionFlowCancelSubscriptionButton:
        "Abo kündigen",
      cancelPanelCancelSubscriptionFlowKeepSubscriptionButton:
        "Abo behalten",
      cancelPanelCancelSubscriptionFlowWarningHeaderMessage:
        "Möchtest du dein Abo wirklich kündigen?",
      cancelPanelCancelSubscriptionFlowReactivateSubscriptionMessage:
        "Kein Problem – du kannst dein Abo jederzeit auf der Seite \"Meine Abonnements\" wieder aktivieren.",
      cancelPanelRenewalMethodFlowSubscriptionPaidMessage:
        "Dieses Abo ist bereits vollständig bezahlt.",
      cancelPanelRenewalMethodFlowSkipUpcomingOrdersMessage:
        "Du kannst bevorstehende Bestellungen jederzeit in der Bestellübersicht überspringen.",
      cancelPanelRenewalMethodFlowSubscriptionRenewalMethodMessage:
        "Nach deiner letzten Bestellung läuft dein Abo wie folgt weiter: {{renewalMethod}}",
      cancelPanelRenewalMethodFlowVaryingPrepaidLengthMessage:
        "Dieses Abo enthält Produkte mit unterschiedlichen Prepaid-Laufzeiten.\nDu kannst jede einzelne Bestellung über die Produktübersicht verwalten.",
      cancelPanelRenewalMethodFlowChangeProductsRenewalMethodButton:
        "Verlängerungsmethode je Produkt ändern",
      cancelPanelRenewalMethodFlowChangeRenewalMethodButton:
        "Verlängerungsmethode ändern",
      cancelPanelRenewalMethodFlowChangeRenewalMethodTitle:
        "Verlängerungsmethode ändern",
      cancelPanelRenewalMethodFlowSuccessMessage:
        "Prepaid-Verlängerungsmethode wurde geändert.",
      cancelPanelRenewalMethodFlowFailureMessage:
        "Die Prepaid-Verlängerungsmethode konnte nicht geändert werden.",
      cancelPanelRenewalMethodFlowRenewalMethodLabel:
        "Verlängerungsmethode",
      cancelPanelRenewalMethodFlowPrepaidRenewalOption:
        "Als Prepaid-Abo verlängern",
      cancelPanelRenewalMethodFlowStandardRenewalOption:
        "Als reguläres Abo verlängern",
      cancelPanelRenewalMethodFlowCancelRenewalOption:
        "Nach der letzten Prepaid-Bestellung kündigen",
      cancelPanelRenewalMethodFlowChangeRenewalMethodCancelButton:
        "Abbrechen",
      cancelPanelRenewalMethodFlowChangeRenewalMethodSaveButton:
        "Änderungen speichern",
      cancelSubscriptionSuccessMessage:
        "Dein Abo wurde gekündigt.",
      cancelSubscriptionLoadSettingsFailureMessage:
        "Kündigungseinstellungen konnten nicht geladen werden …",
      cancelSubscriptionLoadReasonsFailureMessage:
        "Kündigungsgründe konnten nicht geladen werden …",
      cancelSubscriptionFailureMessage:
        "Dein Abo konnte nicht gekündigt werden. Bitte versuche es später erneut.",
      prepaidCancelNoContinueMessage:
        "gekündigt.",
      prepaidCancelAsPrepaidMessage:
        "als Prepaid-Abo verlängert.",
      prepaidCancelAsStandard:
        "als reguläres Abo verlängert.",

      futureOrderDate:
        "{{date, {\"year\": \"numeric\", \"month\": \"long\", \"day\": \"numeric\"} }}",
      subscriptionDatePickerDaySunday:    "So",
      subscriptionDatePickerDayMonday:    "Mo",
      subscriptionDatePickerDayTuesday:   "Di",
      subscriptionDatePickerDayWednesday: "Mi",
      subscriptionDatePickerDayThursday:  "Do",
      subscriptionDatePickerDayFriday:    "Fr",
      subscriptionDatePickerDaySaturday:  "Sa",
      subscriptionDatePickerDayJanuary:   "Januar",
      subscriptionDatePickerDayFebruary:  "Februar",
      subscriptionDatePickerDayMarch:     "März",
      subscriptionDatePickerDayApril:     "April",
      subscriptionDatePickerDayMay:       "Mai",
      subscriptionDatePickerDayJune:      "Juni",
      subscriptionDatePickerDayJuly:      "Juli",
      subscriptionDatePickerDayAugust:    "August",
      subscriptionDatePickerDaySeptember: "September",
      subscriptionDatePickerDayOctober:   "Oktober",
      subscriptionDatePickerDayNovember:  "November",
      subscriptionDatePickerDayDecember:  "Dezember",
      subscriptionDatePickerDayToday:     "Heute",
      subscriptionDatePickerDayClear:     "Zurücksetzen",
      subscriptionDatePickerDayClose:     "Schließen",

      subscriptionSummaryOrderFrequencyTitle:
        "Lieferintervall",
      subscriptionDetailsButton:
        "Details anzeigen",
      subscriptionDetailsButton_toggled:
        "Details ausblenden",
      subscriptionDetailsNoPaymentMethodMessage:
        "Es wurde noch keine Zahlungsmethode hinterlegt.",
      subscriptionDetailsPartiallyFulfilledMessage:
        "Ein oder mehrere Produkte sind derzeit nicht vorrätig. Wir haben deine Bestellung mit den verfügbaren Produkten ausgelöst. Fehlende Produkte werden mit der nächsten Lieferung nachgeliefert.",
      subscriptionSummaryOrderNowButton:
        "Jetzt bestellen",
      subscriptionSummarySubscriptionTitle:
        "Dein Abo \u2013 #{{subscription.bold_platform_subscription_id}}",
      subscriptionSummarySubscriptionTitle_plural:
        "Dein Abo \u2013 #{{subscription.bold_platform_subscription_id}}",
      subscriptionSummaryPrepaidLengthHeader:
        "Dieses Abo enthält Produkte mit unterschiedlichen Prepaid-Laufzeiten.",
      subscriptionSummaryRenewalMethodHeader:
        "Dieses Abo enthält Produkte mit unterschiedlichen Verlängerungsmethoden.",
      subscriptionSummaryNextOrderTitle:
        "Nächste Lieferung:",
      subscriptionSummaryDiscountCodeTitle:
        "Rabattcode",
      subscriptionSummaryPaymentInfoTitle:
        "Zahlungsinformationen",
      subscriptionSummaryProductsTitle:
        "Produkte",
      subscriptionSummaryShippingAddressTitle:
        "Lieferadresse",
      subscriptionSummarySubscriptionPausedMessage:
        "Dein Abo ist pausiert.",
      subscriptionSummaryResumeFutureOrdersButton:
        "Lieferungen fortsetzen",
      subscriptionSummaryEditFutureOrderButton:
        "Zukünftige Bestellung bearbeiten",
      subscriptionSummaryEditFutureOrdersFlowTitle:
        "Zukünftige Bestellung bearbeiten",
      subscriptionSummaryEditFutureOrdersFlowUpdateNextOrderOption:
        "Nur das Datum der nächsten Bestellung ändern",
      subscriptionSummaryEditFutureOrdersFlowUpdateFutureOrdersOption:
        "Alle zukünftigen Bestellungen auf das gewählte Datum anpassen",
      subscriptionSummaryEditFutureOrdersFlowPauseFutureOrdersOption:
        "Zukünftige Bestellungen pausieren",
      subscriptionSummaryEditFutureOrdersFlowSaveChangesButton:
        "Änderungen speichern",
      subscriptionSummaryEditFutureOrdersFlowCancelButton:
        "Abbrechen",
      subscriptionSummaryEditFutureOrdersFlowAdditionalOrderWarningMessage:
        "Dadurch wird sofort eine Bestellung mit allen Produkten deines Abos ausgelöst. Dein nächstes Lieferdatum wird automatisch verschoben.",
      subscriptionSummaryNextOrderProcessingTitle:
        "Deine nächste Bestellung wird gerade verarbeitet.",
      subscriptionSummaryNextOrderFailedToProcessTitle:
        "Deine nächste Bestellung konnte nicht verarbeitet werden.",
      subscriptionSummaryNextOrderProcessingMessage:
        "Deine Bestellung wird gerade bearbeitet. Das kann bis zu {{processingFrequency}} Minuten dauern. Das Datum deiner nächsten Bestellung wird danach automatisch aktualisiert.",
      subscriptionSummaryNextOrderFailedToProcessMessage:
        "Wir versuchen es erneut am {{nextProcessingDate}}.",
      subscriptionSummaryOutOfStockProductMessage:
        "Bei der Verarbeitung deines Abos ist ein Problem aufgetreten. Ein oder mehrere Produkte sind derzeit nicht vorrätig oder nur noch in geringer Menge verfügbar. Wir versuchen automatisch, deine Bestellung am {{nextProcessingDate}} erneut zu verarbeiten.",
      subscriptionSummaryChangeFrequencyButton:
        "Lieferintervall ändern",
      subscriptionSummaryEditFrequencyFlowSaveButton:
        "Speichern",
      subscriptionSummaryEditFrequencyFlowCancelButton:
        "Abbrechen",
      subscriptionFrequencyUpdatedSuccessMessage:
        "Dein Lieferintervall wurde aktualisiert.",
      subscriptionFrequencyUpdatedFailureMessage:
        "Das Lieferintervall konnte nicht aktualisiert werden. Bitte versuche es später erneut.",
      changeNextOrderUpdatedSuccessMessage:
        "Dein Lieferdatum wurde aktualisiert.",
      changeNextOrderResumedSuccessMessage:
        "Dein Abo wurde fortgesetzt.",
      changeNextOrderPausedSuccessMessage:
        "Dein Abo wurde pausiert.",
      changeNextOrderUpdatedFailureMessage:
        "Das Lieferdatum konnte nicht aktualisiert werden. Bitte versuche es später erneut.",
      changeNextOrderResumedFailureMessage:
        "Das Abo konnte nicht fortgesetzt werden. Bitte versuche es später erneut.",
      changeNextOrderPausedFailureMessage:
        "Das Abo konnte nicht pausiert werden. Bitte versuche es später erneut.",

      productsPanelEditActionText:
        "Bearbeiten",
      productsPanelTitle:
        "Produkte in meinem Abo",
      productsPanelSwapFlowShippingAddressWarning:
        "Bitte hinterlege zuerst eine Lieferadresse, bevor du Produkte tauschst.",
      productsPanelSwapFlowDiscountsPersistMessage:
        "(Rabatt wird übernommen)",
      productsPanelSwapFlowOptionsTitle:
        "Produkttausch – bitte wähle die gewünschten Optionen:",
      productsPanelSwapFlowHeaderText:
        "Produkt in deinem Abo tauschen",
      productsPanelSwapFlowHeaderSecondaryText:
        "Diese Änderung wirkt sich auf alle zukünftigen Lieferungen aus. Ein Produktwechsel kann sich auf den Versandpreis auswirken.",
      productsPanelSwapFlowHeaderSecondaryTextWithDynamicDiscountNotice:
        "Diese Änderung wirkt sich auf alle zukünftigen Lieferungen aus. Ein Produktwechsel kann sich auf den Versandpreis auswirken. Bitte beachte: Beim Wechsel eines Produkts werden bestehende dynamische Rabatte zurückgesetzt.",
      productsPanelSwapFlowCancelButton:
        "Tausch abbrechen",
      productsPanelSwapFlowSelectButton:
        "Produkt auswählen",
      productsPanelSwapFlowConfirmText:
        "Möchtest du dieses Produkt wirklich tauschen?",
      productsPanelSwapFlowNoSwappableProducts:
        "Für dieses Abo sind keine austauschbaren Produkte verfügbar.",
      productsPanelSwapFlowSuccessMessage:
        "Dein Produkt wurde getauscht. Bitte überprüfe unter \"Adresse & Versandinformationen\" deine Versandmethode.",
      productsPanelSwapFlowErrorMessage:
        "Das Produkt konnte nicht getauscht werden. Bitte versuche es später erneut.",
      productsPanelSwapFlowShippingAddressMessage:
        "Dieses Produkt benötigt eine Lieferadresse. <button>Bitte hinterlege eine Lieferadresse</button>, bevor du dieses Produkt auswählst.",
      productsPanelSwapFlowVariantSelectLabel:
        "Variante auswählen",
      productsPanelDetailsActionsConfirmRemove:
        "Möchtest du dieses Produkt wirklich aus deinem Abo entfernen?",
      productsPanelDetailsActionsSwapButton:
        "Produkt tauschen",
      productsPanelDetailsActionsRemoveButton:
        "Produkt entfernen",
      productsPanelLineItemDetailQuantity:
        "Menge: {{quantity}}",
      productsPanelContactToSwapProductsMessage:
        "Kontaktiere uns, um dieses Produkt zu tauschen.",
      productsPanelEditFlowCancelButton:
        "Abbrechen",
      productsPanelEditFlowSaveButton:
        "Speichern",
      productsPanelEditFlowSubtotalLabel:
        "Zwischensumme:",
      productsPanelPrepaidRenewalFlowSuccessMessage:
        "Prepaid-Verlängerungsmethode wurde geändert.",
      productsPanelPrepaidRenewalFlowErrorMessage:
        "Die Prepaid-Verlängerungsmethode konnte nicht geändert werden.",
      productsPanelSwapFlowUpdatedChargeMessage:
        "Für zukünftige Bestellungen wird {{amount}} mehr berechnet.",
      productsPanelDeleteLineItemFlowErrorMessage:
        "Das Produkt konnte nicht aus dem Abo entfernt werden. Bitte versuche es später.",
      productsPanelDeleteLineItemFlowSuccessMessage:
        "Produkt aus dem Abo entfernt.",
      productsPanelEditFlowQuantityZeroMessage:
        "Die Menge muss größer als null sein.",
      productsPanelEditFlowSuccessMessage:
        "Dein Abo wurde aktualisiert.",
      productsPanelEditFlowErrorMessage:
        "Das Abo konnte nicht aktualisiert werden. Bitte versuche es später erneut.",

      accountInfoTitle:
        "Kontoinformationen",
      accountInfoMessage:
        "Diese Daten sind direkt mit deinen Abonnements verknüpft.",
      accountInfoEditButton:
        "Bearbeiten",
      accountInfoNameLabel:
        "Name",
      accountInfoEmailLabel:
        "E-Mail-Adresse",
      accountInfoPhoneNumberLabel:
        "Telefonnummer",
      accountInfoEditFirstNameLabel:
        "Vorname",
      accountInfoEditLastNameLabel:
        "Nachname",
      accountInfoEditEmailLabel:
        "E-Mail-Adresse",
      accountInfoEditPhoneNumberLabel:
        "Telefonnummer",
      accountInfoEditFirstNameBlankError:
        "Vorname darf nicht leer sein.",
      accountInfoEditLastNameBlankError:
        "Nachname darf nicht leer sein.",
      accountInfoEditEmailBlankError:
        "E-Mail-Adresse darf nicht leer sein.",
      accountInfoCancelButton:
        "Abbrechen",
      accountInfoSaveButton:
        "Änderungen speichern",
      accountInfoSaveSuccessMessage:
        "Deine Kontodaten wurden gespeichert.",
      accountInfoSaveFailureMessage:
        "Deine Kontodaten konnten nicht gespeichert werden.",

      addressPanelTitle:
        "Adresse & Versandinformationen",
      addressPanelShippingMethodLabel:
        "Versandmethode",
      addressPanelShippingAddressTitle:
        "Lieferadresse",
      addressPanelBillingAddressTitle:
        "Rechnungsadresse",
      addressPanelCreateSuccessMessage:
        "Deine Adresse wurde gespeichert.",
      addressPanelCreateErrorMessage:
        "Die Adresse konnte nicht gespeichert werden. Bitte versuche es später erneut.",
      addressPanelUpdateSuccessMessage:
        "Deine Adresse wurde aktualisiert. Bitte überprüfe anschließend deine Versandmethode.",
      addressPanelUpdateErrorMessage:
        "Die Adresse konnte nicht aktualisiert werden. Bitte versuche es später erneut.",
      addressPanelSaveButton:
        "Änderungen speichern",
      addressPanelCancelButton:
        "Abbrechen",
      addressPanelMissingAddressMessage:
        "Keine Adresse gefunden.",
      addressPanelAddressNotRequiredMessage:
        "Eine {{addressType}} ist für die ausgewählten Produkte nicht erforderlich.",
      addressPanelEditShippingTitle:
        "Lieferadresse",
      addressPanelEditSameAddressLabel:
        "Gleich wie Lieferadresse",
      addressPanelEditExistingAddressLabel:
        "Gespeicherte Adresse verwenden",
      addressPanelEditExistingAddressSelectLabel:
        "Gespeicherte Adresse auswählen",
      addressPanelEditExistingAddressSelectMessage:
        "Adresse auswählen",
      addressPanelEditExistingAddressDeleted:
        "Diese Adresse wurde gelöscht. Bitte wähle eine andere oder gib eine neue Adresse ein.",
      addressPanelEditBillingTitle:
        "Rechnungsadresse",
      addressPanelEditProvinceLabel:
        "Bundesland",
      addressPanelEditProvincePlaceholder:
        "Bundesland",
      addressPanelEditFirstNameLabel:
        "Vorname",
      addressPanelEditFirstNamePlaceholder:
        "Vorname",
      addressPanelEditLastNameLabel:
        "Nachname",
      addressPanelEditLastNamePlaceholder:
        "Nachname",
      addressPanelEditCompanyLabel:
        "Firma (optional)",
      addressPanelEditCompanyPlaceholder:
        "Firmenname",
      addressPanelEditPhoneLabel:
        "Telefonnummer",
      addressPanelEditPhonePlaceholder:
        "Telefonnummer",
      addressPanelEditStreet1Label:
        "Straße und Hausnummer",
      addressPanelEditStreet1Placeholder:
        "Straße und Hausnummer",
      addressPanelEditStreet2Label:
        "Adresszusatz (optional)",
      addressPanelEditStreet2Placeholder:
        "Adresszusatz",
      addressPanelEditCityLabel:
        "Stadt",
      addressPanelEditCityPlaceholder:
        "Stadt",
      addressPanelEditCountryLabel:
        "Land",
      addressPanelEditZipLabel:
        "Postleitzahl",
      addressPanelEditZipPlaceholder:
        "Postleitzahl",
      addressPanelEditFirstNameMissingError:
        "Bitte gib deinen Vornamen ein.",
      addressPanelEditLastNameMissingError:
        "Bitte gib deinen Nachnamen ein.",
      addressPanelEditPhoneMissingError:
        "Bitte gib deine Telefonnummer ein.",
      addressPanelEditStreet1MissingError:
        "Bitte gib Straße und Hausnummer ein.",
      addressPanelEditCityMissingError:
        "Bitte gib deine Stadt ein.",
      addressPaneEditZipMissingError:
        "Bitte gib deine Postleitzahl ein.",
      addressPanelEditMissingRequiredFieldsMessage:
        "Bitte fülle alle Pflichtfelder aus.",

      manageUpcomingOrdersPanelTitle:
        "Bevorstehende Bestellungen verwalten",
      manageUpcomingOrdersPanelUpcomingOrdersTitle:
        "Bevorstehende Bestellungen",
      manageUpcomingOrdersPanelChangesAffectFutureOrdersMessage:
        "Diese Änderungen betreffen alle zukünftigen Bestellungen.",
      manageUpcomingOrdersPanelPauseFutureOrdersButton:
        "Zukünftige Bestellungen pausieren",
      manageUpcomingOrdersPanelOrderNowButton:
        "Jetzt bestellen",
      manageUpcomingOrdersPanelOrderDateTitle:
        "Bestelldatum",
      manageUpcomingOrdersPanelProductTitle:
        "Produkte",
      manageUpcomingOrdersPanelSkipShipmentFlowOrderCurrentlySkipMessage:
        "(Diese Bestellung wird übersprungen)",
      manageUpcomingOrdersPanelSkipShipmentFlowSkipOrderSuccessMessage:
        "Bestellung übersprungen.",
      manageUpcomingOrdersPanelSkipShipmentFlowSkipOrderFailureMessage:
        "Die Bestellung konnte nicht übersprungen werden.",
      manageUpcomingOrdersPanelSkipShipmentFlowSkipShipmentButton:
        "Lieferung überspringen",
      manageUpcomingOrdersPanelSkipShipmentFlowSkipShipmentConfirmationMessage:
        "Möchtest du diese Lieferung wirklich überspringen?",
      manageUpcomingOrdersPanelRecoverShipmentFlowRecoverShipmentButton:
        "Lieferung wiederherstellen",
      manageUpcomingOrdersPanelRecoverShipmentFlowRecoverShipmentConfirmationMessage:
        "Möchtest du diese Lieferung wirklich wiederherstellen?",
      manageUpcomingOrdersPanelRecoverShipmentFlowRecoverOrderSuccessMessage:
        "Bestellung wiederhergestellt.",
      manageUpcomingOrdersPanelRecoverShipmentFlowRecoverOrderFailureMessage:
        "Die Bestellung konnte nicht wiederhergestellt werden.",
      manageUpcomingOrdersPanelPauseFutureOrdersFlowOrdersPauseOrderSuccessMessage:
        "Bestellung pausiert.",
      manageUpcomingOrdersPanelPauseFutureOrdersFlowOrdersPauseOrderFailureMessage:
        "Die Bestellung konnte momentan nicht pausiert werden.",
      manageUpcomingOrdersPanelRemoveOneTimeProductConfirmationMessage:
        "Möchtest du \"{{productTitle}}\" wirklich aus deiner Bestellung vom {{orderDate}} entfernen?",
      manageUpcomingOrdersPanelRemoveAdjustmentProductSuccessMessage:
        "Einmaliges Produkt entfernt.",
      manageUpcomingOrdersPanelRemoveAdjustmentProductFailureMessage:
        "Das einmalige Produkt konnte momentan nicht entfernt werden.",
      manageUpcomingOrdersAdjustmentProductDefaultLabel:
        "Einmalig",
      manageUpcomingOrdersRemoveOneTimeProductButtonText:
        "Entfernen",
      manageUpcomingOrdersPanelOrderNowFlowOrderShipOrderSuccessMessage:
        "Bestellung ausgelöst.",
      manageUpcomingOrdersPanelOrderNowFlowOrderShipOrderFailureMessage:
        "Die Bestellung konnte momentan nicht ausgelöst werden.",

      panelEditText:
        "Bearbeiten",
      panelEditText_toggled:
        "Schließen",

      paymentPanelTitle:
        "Zahlungsinformationen",
      paymentPanelEmailUpdateFlowNoPaymentMethod:
        "Es wurde noch keine Zahlungsmethode hinterlegt.",
      paymentPanelEmailUpdateFlowEmailSent:
        "Wir haben dir eine E-Mail geschickt, um deine Zahlungsdaten zu aktualisieren.",
      paymentPanelEmailUpdateFlowResendEmailButton:
        "Erneut senden",
      paymentPanelEmailUpdateFlowReturnButton:
        "Zurück zur vorherigen Seite",
      paymentPanelEmailUpdateFlowCreditCardDetails:
        "Kreditkarte – {{ccType}}, endet auf {{lastFour}}",
      paymentPanelEmailUpdateFlowBillingAddressTitle:
        "Rechnungsadresse",
      paymentPanelEmailUpdateFlowChangePaymentButton:
        "Zahlungsdaten ändern",
      paymentPanelEmailUpdateFlowChangePaymentDetails:
        "Du erhältst eine E-Mail mit einem sicheren Link, um deine Zahlungsdaten zu ändern.",
      paymentPanelEmailUpdateFlowResendEmailConfirmation:
        "Falls du keine E-Mail erhalten hast, überprüfe deine Angaben und klicke auf \"Erneut senden\".",
      paymentPanelEmailUpdateFlowTitle:
        "Zahlungsmethode",
      paymentPanelUrlUpdateFlowNoPaymentMethod:
        "Es wurde noch keine Zahlungsmethode hinterlegt.",
      paymentPanelUpdateSuccessMessage:
        "Deine Zahlungsmethode wurde aktualisiert.",
      paymentPanelAddSuccessMessage:
        "Deine Zahlungsmethode wurde hinzugefügt.",
      paymentPanelEmailUpdateFlowResendEmailHelpText:
        "Suche in deinem Postfach nach der E-Mail mit dem Betreff: \"Zahlungsdetails bearbeiten\".<br>Falls du sie nicht findest, schau auch im Spam-Ordner nach und klicke auf \"Erneut senden\".",
      paymentPanelListUpdateErrorMessage:
        "Die Zahlungsmethode konnte nicht aktualisiert werden.",
      paymentPanelListUpdateSuccessMessage:
        "Deine Zahlungsmethode wurde aktualisiert.",
      paymentPanelListLoadFailMessage:
        "Zahlungsmethoden konnten nicht geladen werden.",
      paymentPanelListPaypalLabel:
        "PayPal – {{paypalEmail}}",
      paymentPanelListCCLabel:
        "{{ccType}} – endet auf {{lastFour}} (gültig bis {{expiry}})",
      paymentPanelListAmazonPayLabel:
        "{{ccType}} – endet auf {{lastFour}}",
      paymentPanelListEditButton:
        "Bearbeiten",
      paymentPanelListChangeDefaultCardButton:
        "Zahlungsmethode bearbeiten",
      paymentPanelListAddButton:
        "Zahlungsmethode hinzufügen",
      paymentPanelListAddAltButton:
        "Geschenkkarte hinzufügen",
      paymentPanelListCancelButton:
        "Abbrechen",
      paymentPanelListSaveButton:
        "Änderungen speichern",
      paymentPanelListLoadErrorMessage:
        "Zahlungsmethoden konnten nicht geladen werden.",
      paymentPanelEditErrorMessage:
        "Beim Laden der Zahlungsmethode ist ein Fehler aufgetreten. Bitte versuche es später erneut.",
      paymentPanelPaymentTitle:
        "Zahlungsmethoden",
      altPaymentSummaryCardTitle:
        "Geschenkkarten",
      altPaymentSummaryCardPrefix:
        "Geschenkkarte:",
      paymentSummaryCardPrefix:
        "Kreditkarte:",
      paymentSummaryCardTitle:
        "Zahlungsmethoden",
      paymentSummaryNoPaymentMethodMessage:
        "Es wurde noch keine Zahlungsmethode hinterlegt.",
      altPaymentSummaryCardMessage:
        "{{balance}} $ Guthaben verbleibend",
      paymentPanelInvalidAltPayment:
        "Ungültige Nummer oder PIN. Bitte versuche es erneut.",
      paymentMethodSummaryEndingInMessage:
        "endet auf {{lastFour}}",
      paymentMethodSummaryAccountMessage:
        "Konto {{account}}",
      paymentMethodSummaryAmazonPayLabel:
        "Amazon Pay",
      paymentMethodSummaryApplePayLabel:
        "Apple Pay",
      paymentMethodSummaryPayPalLabel:
        "PayPal",
      paymentMethodSummaryShopPayLabel:
        "Shop Pay",
      paymentMethodSummaryVenmo:
        "Venmo",

      orderHistoryPanelTitle:
        "Bestellhistorie",
      orderHistoryPanelPricesDiscountsApplyMessage:
        "Die angezeigten Preise beinhalten bereits angewendete Rabatte (vor Steuern).",
      orderHistoryPanelOrderIdColumn:
        "Bestellnummer",
      orderHistoryPanelSubtotalColumn:
        "Zwischensumme",
      orderHistoryPanelTaxColumn:
        "Steuer",
      orderHistoryPanelShippingColumn:
        "Versand",
      orderHistoryPanelTotalColumn:
        "Gesamt",
      orderHistoryPanelDateCreatedColumn:
        "Erstellt am",

      activeSubscriptionsTitle:
        "Meine Abonnements",
      activeSubscriptionsSubtitle:
        "Aktive Abonnements",
      noActiveSubscriptionsMessage:
        "Du hast derzeit keine aktiven Abonnements.",
      viewInactiveSubscriptionsTitle:
        "Inaktive Abonnements anzeigen und reaktivieren",
      viewInactiveSubscriptionsMessage:
        "Hier findest du frühere Abonnements und kannst sie bei Bedarf wieder aktivieren.",
      viewInactiveSubscriptionsButton:
        "Inaktive Abonnements anzeigen",
      inactiveSubscriptionsTitle:
        "Inaktive Abonnements",
      inactiveSubscriptionsCount:
        "{{count}} inaktives Abonnement",
      inactiveSubscriptionsCount_plural:
        "{{count}} inaktive Abonnements",
      hideInactiveSubscriptionsButton:
        "Inaktives Abonnement ausblenden",
      hideInactiveSubscriptionsButton_plural:
        "Inaktive Abonnements ausblenden",
      reactivateSubscriptionButton:
        "Abo reaktivieren",
      reactivateSubscriptionConfirmationMessage:
        "Möchtest du dieses Abo wirklich reaktivieren?",
      reactivateSubscriptionNextOrderMessage:
        "Deine nächste Lieferung erfolgt am: {{date, {\"year\": \"numeric\", \"month\": \"long\", \"day\": \"numeric\"} }}.",
      reactivateSubscriptionCancelButton:
        "Nein, Abo nicht reaktivieren",
      reactivateSubscriptionConfirmationButton:
        "Ja, Abo reaktivieren",
      inactiveSubscriptionName:
        "{{count}} Produkte im Abo",
      reactivationFailureMessage:
        "Das Abo konnte nicht reaktiviert werden. Bitte versuche es später erneut.",
      reactivationSuccessMessage:
        "Dein Abo wurde reaktiviert.",

      loadingSubscriptionsMessage:
        "Deine Abonnements werden geladen …",
      loadingSubscriptionsLoggedOutError:
        "Bitte melde dich an, um deine Abonnements zu sehen.",
      loadingSubscriptionsError:
        "Beim Laden ist ein Fehler aufgetreten.",
      loadingSubscriptionsComponentError:
        "Bei der Konfiguration der Komponente ist ein Fehler aufgetreten.",

      passwordlessLoginSecured:
        "Sicher & verschlüsselt",
      passwordlessLoginHeader:
        "Zu deinen Abonnements",
      passwordlessLoginDescription:
        "Kein Passwort nötig. Gib einfach deine E-Mail-Adresse ein – wir schicken dir einen Einmal-Anmeldelink direkt in dein Postfach.",
      passwordlessLoginInputLabel:
        "E-Mail-Adresse",
      passwordlessLoginInputPlaceholder:
        "E-Mail-Adresse eingeben",
      passwordlessLoginButtonLabel:
        "Einmal-Anmeldelink senden",
      passwordlessLoginSuccessHeader:
        "Fast geschafft – check deine E-Mails!",
      passwordlessLoginSuccessDescription:
        "Wir haben einen Anmeldelink an {{email}} geschickt. Falls diese Adresse in unserem System hinterlegt ist, findest du dort deinen persönlichen Einmal-Anmeldelink.",
      passwordlessLoginSuccessFooter:
        "Der Link ist 15 Minuten gültig – also am besten gleich nutzen.",
      passwordlessLoginInvalidHeader:
        "Ungültiger Link",
      passwordlessLoginInvalidDescription:
        "Dieser Link ist leider nicht mehr gültig. Klicke auf den Button unten, um einen neuen Einmal-Anmeldelink zu erstellen.",
      passwordlessLoginInvalidButtonLabel:
        "Neuen Anmeldelink anfordern",

      loggedInAsCustomerMessage:
        "Du bist als Kundschaft im Kundenportal eingeloggt. Alle Änderungen werden im jeweiligen Kundenkonto gespeichert.",

      subscriptionValidationMissingPhoneWithLink:
        "<p>Speichern nicht möglich. <button>Bitte hinterlege eine Telefonnummer</button> und versuche es erneut.</p>",
      subscriptionValidationMissingPhone:
        "Speichern nicht möglich. Bitte hinterlege eine Telefonnummer und versuche es erneut.",
      subscriptionValidationMissingZipWithLink:
        "<p>Speichern nicht möglich. <button>Bitte gib eine Postleitzahl ein</button> und versuche es erneut.</p>",
      subscriptionValidationMissingZip:
        "Speichern nicht möglich. Bitte gib eine Postleitzahl ein und versuche es erneut.",
      subscriptionValidationInvalidZipWithLink:
        "<p>Speichern nicht möglich. Die hinterlegte Postleitzahl ist ungültig. <button>Bitte gib eine gültige Postleitzahl ein</button> und versuche es erneut.</p>",
      subscriptionValidationInvalidZip:
        "Speichern nicht möglich. Die hinterlegte Postleitzahl ist ungültig. Bitte gib eine gültige Postleitzahl ein und versuche es erneut.",
      subscriptionValidationInvalidShippingAddressCustomerMessage:
        "Speichern nicht möglich. Für dieses Abo ist keine Versandmethode hinterlegt. Bitte kontaktiere uns für weitere Unterstützung.",

      scaWaiting:
        "Für dieses Abo ist eine Zahlungsauthentifizierung erforderlich. Du kannst dein Abo erst bearbeiten, nachdem die Authentifizierung abgeschlossen ist. Falls dein Link abgelaufen ist, fordere bitte einen neuen an.",
      scaGeneratingLink:
        "Du erhältst in Kürze eine E-Mail mit dem neuen Link. Das kann bis zu 60 Minuten dauern.",
      scaAuthenticating:
        "Wenn du die Zahlung bereits authentifiziert hast, warte einen Moment und aktualisiere die Seite. Falls der Link nicht funktioniert hat, fordere einen neuen an.",
      scaError:
        "Es ist ein Fehler aufgetreten. Ein neuer Link konnte nicht erstellt werden. Bitte versuche es später erneut.",
      ScaWaitingBoldCheckout:
        "Für dieses Abo ist eine Zahlungsauthentifizierung erforderlich. Du kannst dein Abo erst bearbeiten, nachdem die Authentifizierung abgeschlossen ist.",
      scaSuccessBoldCheckout:
        "Erfolgreich! Deine Zahlungsmethode wurde authentifiziert. Bitte beachte, dass die Aktualisierung deines Abos bis zu {{processingFrequency}} Minuten dauern kann.",
      scaFailedBoldCheckout:
        "Authentifizierung fehlgeschlagen. Deine Zahlungsmethode konnte nicht authentifiziert werden.",
      scaErrorBoldCheckout:
        "Es ist ein Fehler aufgetreten. Deine Zahlungsmethode konnte nicht authentifiziert werden.",

      addProductsButton:
        "Produkte hinzufügen",
      addProductMessage:
        "Produkt hinzufügen",
      addProductsTitle:
        "Produkte zu deinem Abo hinzufügen",
      addProductsNoProductsErrorMessage:
        "Fehler beim Laden der Produkte. Bitte versuche es erneut.",
      addProductsNoProductErrorMessage:
        "Fehler beim Abrufen des Produkts. Bitte versuche es erneut.",
      addProductsAddingErrorMessage:
        "Das Produkt konnte nicht zu deinem Abo hinzugefügt werden. Bitte versuche es erneut.",
      addProductsRetrieveSubscriptionErrorMessage:
        "Dein Abo konnte nicht geladen werden. Bitte versuche es erneut.",
      addProductsBackButton:
        "Zurück zu den Produkten",
      addProductsToSubscriptionButton:
        "Zum Abo hinzufügen",
      addProductsTargetSubscription:
        "Abo",
      addProductsTargetNextOrder:
        "nächste Bestellung",
      addProductsSuccessTitle:
        "{{productName}} wurde zu deiner {{addProductsTarget}} hinzugefügt.",
      addProductsSuccessMessage:
        "<p>{{productName}} wird zu deiner nächsten Lieferung am {{nextOrderDate}} hinzugefügt.</p><p>Dein neuer Zwischenbetrag beträgt <strong>{{newTotal}}</strong> und wird über deine gespeicherte Zahlungsmethode abgerechnet.</p><p>Bitte überprüfe unter \"Adresse & Versandinformationen\" deine Versandmethode.</p>",
      addProductsManageSubscriptionButton:
        "Abo verwalten",
      addProductsAddMoreButton:
        "Weitere Produkte hinzufügen",
      addProductsSearchPlaceholder:
        "Suchen",
      addProductsSubscriptionProductTooltipText:
        "Abo-Produktpreis in {{currencyCode}}",
      addProductsOneTimeProductTooltipText:
        "Einmaliger Kaufpreis in {{currencyCode}}",
      addProductsQuantityLabel:
        "Menge",
      addProductsValidateQuantityError:
        "Bitte gib eine gültige Menge ein.",
      addProductsOptionSelectorPlaceholder:
        "Option auswählen",
      addProductsAddToNextOrderButton:
        "Nur zur nächsten Bestellung hinzufügen – {{formattedPrice}}",
      addProductsAddToSubscriptionButton:
        "Zum Abo hinzufügen – {{formattedPrice}}",
      addProductsOneTimeAdjustmentName:
        "Einmalig",
      addProductsOnetimeAdjustmentDescription:
        "Fügt {{quantity}}x \"{{title}}\" zur nächsten Bestellung hinzu.",
      addProductsPriceForSubscribers:
        "{{formattedPrice}} als Abo",
      addProductsVariantNotFoundMessage:
        "Das Produkt konnte anhand deiner Auswahl nicht gefunden werden. Bitte versuche es erneut.",
      addProductsNoMatchesMessage:
        "Keine Ergebnisse gefunden. Versuche eine andere Suche oder kontaktiere uns.",

      upsellWidgetAddProductMessage:
        "Produkt hinzufügen",
      upsellWidgetAddedProductMessage:
        "Hinzugefügt",
      upsellWidgetProductDetailsBackButton:
        "Zurück zu den Produkten",
      upsellWidgetProductDetailsAddMoreButton:
        "Weitere Produkte hinzufügen",
      upsellWidgetSubscriptionPriceCurrencyTooltipText:
        "Abo-Produktpreis in {{currencyCode}}",
      upsellWidgetOneTimeProductTooltipText:
        "Einmaliger Kaufpreis in {{currencyCode}}",
      upsellWidgetProductCardAddErrorText:
        "Es ist ein Fehler aufgetreten. Bitte versuche es erneut.",
      upsellWidgetProductDetailsErrorText:
        "Es ist ein Fehler aufgetreten. Bitte versuche es erneut.",
      upsellWidgetPriceForSubscribers:
        "{{formattedPrice}} als Abo",
      upsellWidgetAddToSubscriptionButton:
        "Zum Abo hinzufügen – {{formattedPrice}}",
      upsellWidgetAddToNextOrderButton:
        "Nur zur nächsten Bestellung – {{formattedPrice}}",
      upsellWidgetAddSuccessTitle:
        "{{productName}} wurde zu deiner {{addProductsTarget}} hinzugefügt.",
      upsellWidgetTargetSubscription:
        "Abo",
      upsellWidgetTargetNextOrder:
        "nächste Bestellung",
      upsellWidgetAddSuccessMessage:
        "<p>{{productName}} wird zu deiner nächsten Lieferung am {{nextOrderDate}} hinzugefügt.</p><p>Dein neuer Zwischenbetrag beträgt <strong>{{newTotal}}</strong> und wird über deine gespeicherte Zahlungsmethode abgerechnet.</p>",
      upsellWidgetOneTimeAdjustmentName:
        "Einmalig",
      upsellWidgetOnetimeAdjustmentDescription:
        "Fügt {{quantity}}x \"{{title}}\" zur nächsten Bestellung hinzu.",

      discountComponentRegularPriceLabel:
        "Regulärer Preis",

      expressAddOnOneTimeSuccess:
        "<strong>{{itemTitle}} x {{quantity}}</strong> wurde zu deiner nächsten Bestellung am {{longDate}} hinzugefügt. Dein neuer Zwischenbetrag beträgt <strong>{{newTotal}}</strong> und wird über deine gespeicherte Zahlungsmethode abgerechnet. {{portalLink}}",
      expressAddOnSubsSuccess:
        "<strong>{{itemTitle}} x {{quantity}}</strong> wurde zu deinem Abo #{{bold_platform_subscription_id}} hinzugefügt. Dieser Artikel wird in deiner nächsten Bestellung am {{longDate}} geliefert. Dein neuer Zwischenbetrag beträgt <strong>{{newTotal}}</strong> und wird über deine gespeicherte Zahlungsmethode abgerechnet. {{portalLink}}",
      insufficientProductFailure:
        "Deine nächste Abo-Bestellung konnte nicht verarbeitet werden, da {{productName}} nicht ausreichend vorrätig ist. Bitte überprüfe dein Abo oder kontaktiere uns für Unterstützung.",

      manageShippingLoadDeliveryOptionsTimeoutErr:
        "Das Laden der verfügbaren Versandmethoden hat zu lange gedauert. Bitte versuche es in 10 Minuten erneut. Falls das Problem bestehen bleibt, kontaktiere uns.",
      manageShippingNoAvailableDeliveryOptions:
        "Für deine Produkte wurde noch keine Versandmethode eingerichtet. Bitte kontaktiere uns für Unterstützung.",
      manageShippingUpdateSuccessMessage:
        "Deine Versandmethode wurde auf \"{{title}}\" geändert.",
      manageShippingPickupUpdateSuccessMessage:
        "Dein Abholort wurde auf {{title}} geändert.",
      manageShippingPickupInStoreMethod:
        "Abholung im Geschäft",
      manageShippingAddAddressToEditShippingMethod:
        "Bitte hinterlege eine Lieferadresse in deinem Abo, um die Versandmethode bearbeiten zu können.",

      subscriptionSummaryOrderNoteTitle:        "Bestellnotiz",
      subscriptionSummaryOrderNoteLabel:        "Bestellnotiz",
      orderNoteTitle:                           "Bestellnotiz",
      orderNoteLabel:                           "Bestellnotiz",
      subscriptionSummaryAddNoteButton:         "Notiz hinzufügen",
      subscriptionSummaryOrderNoteAddNoteButton:"Notiz hinzufügen",
      orderNoteAddNoteButton:                   "Notiz hinzufügen",
      addNoteButton:                            "Notiz hinzufügen",

    }
  }
};

(function injectURStyles() {
  if (document.getElementById('ur-injected-styles')) return;
  var s = document.createElement('style');
  s.id = 'ur-injected-styles';
  s.textContent =
    '#customer-portal-root .bsub-flex-grid .details-section,' +
    '#bsub-admin-root .bsub-flex-grid .details-section,' +
    '#customer-portal-root .bsub-flex-grid [data-ur-moved="1"],' +
    '#bsub-admin-root .bsub-flex-grid [data-ur-moved="1"] {' +
    '  flex-direction: column !important;' +
    '  align-items: flex-start !important;' +
    '}' +
    '#customer-portal-root .active-subscription__extended > *,' +
    '#customer-portal-root .active-subscription__extended > * > *,' +
    '#bsub-admin-root .active-subscription__extended > *,' +
    '#bsub-admin-root .active-subscription__extended > * > * {' +
    '  border: none !important;' +
    '  border-top: none !important;' +
    '  border-bottom: none !important;' +
    '  outline: none !important;' +
    '}' +
    '#customer-portal-root [class*="accordion"],' +
    '#bsub-admin-root [class*="accordion"] {' +
    '  border: none !important;' +
    '  border-top: none !important;' +
    '  border-bottom: none !important;' +
    '}';
  (document.head || document.documentElement).appendChild(s);
})();

(function () {

  var replacements = [

    { find: 'Order Note',                                        replace: 'Bestellnotiz' },
    { find: 'Add note',                                          replace: 'Notiz hinzufügen' },

    { find: 'Inactive subscriptions',                            replace: 'Inaktive Abonnements' },
    { find: 'Discount code',                                     replace: 'Rabattcode' },
    { find: 'Products',                                          replace: 'Produkte' },
    { find: 'Payment info',                                      replace: 'Zahlungsinformationen' },
    { find: 'Order frequency',                                   replace: 'Bestellhäufigkeit' },
    { find: 'Shipping address',                                  replace: 'Lieferadresse' },
    { find: 'Account info',                                      replace: 'Kontoinfo' },
    { find: 'Billing address',                                   replace: 'Rechnungsadresse' },
    { find: 'Next order',                                        replace: 'Nächste Lieferung' },
    { find: 'Upcoming orders',                                   replace: 'Bevorstehende Bestellungen' },
    { find: 'Order history',                                     replace: 'Bestellhistorie' },

    { find: 'ADD PRODUCTS',                                      replace: 'Produkte hinzufügen' },
    { find: 'Add products',                                      replace: 'Produkte hinzufügen' },
    { find: 'HIDE INACTIVE SUBSCRIPTION',                        replace: 'Inaktive Abonnements ausblenden' },
    { find: 'Hide inactive subscription',                        replace: 'Inaktive Abonnements ausblenden' },
    { find: 'HIDE INACTIVE SUBSCRIPTIONS',                       replace: 'Inaktive Abonnements ausblenden' },
    { find: 'Hide inactive subscriptions',                       replace: 'Inaktive Abonnements ausblenden' },
    { find: 'INACTIVE ABOS ANZEIGEN',                            replace: 'Inaktive Abonnements anzeigen' },
    { find: 'View details',                                      replace: 'Details anzeigen' },
    { find: 'Hide details',                                      replace: 'Details ausblenden' },
    { find: 'Skip shipment',                                     replace: 'Lieferung überspringen' },
    { find: 'SKIP SHIPMENT',                                     replace: 'Lieferung überspringen' },
    { find: 'Cancel subscription',                               replace: 'Abo kündigen' },
    { find: 'CANCEL SUBSCRIPTION',                               replace: 'Abo kündigen' },
    { find: 'Reactivate subscription',                           replace: 'Abo reaktivieren' },
    { find: 'REACTIVATE SUBSCRIPTION',                           replace: 'Abo reaktivieren' },
    { find: 'Change frequency',                                  replace: 'Intervall ändern' },
    { find: 'Order now',                                         replace: 'Jetzt bestellen' },
    { find: 'ORDER NOW',                                         replace: 'Jetzt bestellen' },
    { find: 'NUR ZUR NÄCHSTEN BESTELLUNG HINZUFÜGEN',            replace: 'Nur zur nächsten Bestellung hinzufügen' },

    { find: 'Adding products may impact the price of delivery.', replace: 'Das Hinzufügen von Produkten kann den Versandpreis beeinflussen.' },
    { find: 'Swapping products may impact the price of delivery.', replace: 'Ein Produktwechsel kann den Versandpreis beeinflussen.' },
    { find: 'This note will appear on future orders',            replace: 'Diese Notiz wird bei zukünftigen Bestellungen angezeigt.' },
    { find: 'SAVE',                                              replace: 'Speichern' },
    { find: 'Save',                                              replace: 'Speichern' },
    { find: 'Save changes',                                      replace: 'Änderungen speichern' },
    { find: 'SAVE CHANGES',                                      replace: 'Änderungen speichern' },
    { find: 'CANCEL',                                            replace: 'Abbrechen' },
    { find: 'Cancel',                                            replace: 'Abbrechen' },
    { find: 'REMOVE DISCOUNT',                                   replace: 'Rabatt entfernen' },
    { find: 'Remove discount',                                   replace: 'Rabatt entfernen' },
  ];

  var regexReplacements = [
    {

      pattern: /.+[\u2013\-]\s*#(\d{5,})/g,
      replace: function (_, id) { return 'Dein Abo \u2013 #' + id; }
    },
    {

      pattern: /(\d+)\s+inactive subscriptions?/gi,
      replace: function (_, n) { return n + ' inaktive Abonnement' + (n === '1' ? '' : 's'); }
    },
  ];

  function walkTextNodes(root, callback) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var node;
    while ((node = walker.nextNode())) {
      callback(node);
    }
  }

  var pending = false;
  function applyReplacements() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      var root = document.getElementById('customer-portal-root') || document.body;

      walkTextNodes(root, function (node) {
        var original = node.nodeValue;
        var text = original;

        replacements.forEach(function (r) {
          if (text.trim() === r.find) text = r.replace;
        });

        regexReplacements.forEach(function (r) {
          text = text.replace(r.pattern, r.replace);
        });

        if (text !== original) node.nodeValue = text;
      });

      replacements.forEach(function (r) {
        root.querySelectorAll('[aria-label="' + r.find + '"]').forEach(function (el) {
          el.setAttribute('aria-label', r.replace);
        });
      });

      root.querySelectorAll('textarea[placeholder], input[placeholder]').forEach(function (el) {
        if (el.getAttribute('placeholder') === 'Add a note for your future orders...') {
          el.setAttribute('placeholder', 'Notiz für zukünftige Bestellungen hinzufügen …');
        }
      });

      root.querySelectorAll('button').forEach(function (btn) {
        if (btn.hasAttribute('aria-expanded')) return;
        var t = btn.textContent.trim().toLowerCase();
        if (t.indexOf('kündigen') === -1 && t.indexOf('cancel subscription') === -1) return;
        if (t.indexOf('ja,') !== -1) return;

        var prev = btn.previousElementSibling;
        if (prev && prev.classList.contains('ur-cancel-hint')) return;
        var hint = document.createElement('p');
        hint.className = 'ur-cancel-hint';
        hint.textContent = 'Nach der Kündigung erhältst du keine weiteren Lieferungen mehr. Du kannst dein Abo jederzeit unter \u201eInaktive Abonnements\u201c wieder reaktivieren.';
        btn.parentNode.insertBefore(hint, btn);
      });

      root.querySelectorAll('[class*="shipping-and-address"]').forEach(function (panel) {
        var headers = panel.querySelectorAll('.bsub-highlighted-header');
        for (var hi = 0; hi < headers.length; hi++) {
          var header = headers[hi];
          var ht = header.textContent.trim().toLowerCase();
          if (ht !== 'lieferadresse' && ht !== 'shipping address') continue;
          if (header.getAttribute('data-ur-btn-moved')) continue;
          var editBtn = panel.querySelector('.edit-text-button');
          if (!editBtn) continue;
          header.setAttribute('data-ur-btn-moved', '1');
          if (header.parentNode) {
            header.parentNode.insertBefore(editBtn, header.nextSibling);
          }
          editBtn.style.setProperty('display', 'block', 'important');
          editBtn.style.setProperty('width', 'auto', 'important');
          editBtn.style.setProperty('margin-top', '8px', 'important');
          editBtn.style.setProperty('margin-bottom', '10px', 'important');
        }
      });

      root.querySelectorAll('.bsub-highlighted-header').forEach(function (header) {
        var t = header.textContent.trim().toLowerCase();
        if (t !== 'versandmethode' && t !== 'shipping method') return;
        var section = header.parentElement;
        if (!section) return;
        var container = section.parentElement;
        if (!container || container.getAttribute('data-ur-shipping-hidden')) return;
        container.setAttribute('data-ur-shipping-hidden', '1');
        container.style.setProperty('display', 'none', 'important');
        var sib = container.nextElementSibling;
        while (sib) {
          var sibHeaders = sib.querySelectorAll ? sib.querySelectorAll('.bsub-highlighted-header') : [];
          var found = false;
          for (var j = 0; j < sibHeaders.length; j++) {
            var ht = sibHeaders[j].textContent.trim().toLowerCase();
            if (ht === 'lieferadresse' || ht === 'shipping address' || ht === 'delivery address') { found = true; break; }
          }
          if (found) break;
          sib.style.setProperty('display', 'none', 'important');
          sib = sib.nextElementSibling;
        }
      });

      var allEls = root.querySelectorAll('span, div, label');
      for (var i = 0; i < allEls.length; i++) {
        var el = allEls[i];
        if (el.childElementCount > 0) continue;
        var t = el.textContent.trim().toLowerCase();
        if (t !== 'lieferadresse' && t !== 'shipping address' && t !== 'delivery address') continue;
        var lieferBlock = el.parentElement && el.parentElement.parentElement;
        if (!lieferBlock || lieferBlock.getAttribute('data-ur-moved')) continue;
        var inPanel = false;
        var p = lieferBlock.parentElement;
        while (p && p !== root) {
          if (p.className && typeof p.className === 'string' && p.className.indexOf('shipping-and-address') !== -1) { inPanel = true; break; }
          p = p.parentElement;
        }
        if (inPanel) continue;
        var flexGrid = null;
        var c = lieferBlock.parentElement;
        while (c && c !== root) {
          var fg = c.querySelector('.bsub-flex-grid');
          if (fg) { flexGrid = fg; break; }
          c = c.parentElement;
        }
        if (!flexGrid) continue;
        lieferBlock.setAttribute('data-ur-moved', '1');
        flexGrid.insertBefore(lieferBlock, flexGrid.children[1] || null);
        lieferBlock.style.setProperty('flex-direction', 'column', 'important');
        lieferBlock.style.setProperty('align-items', 'flex-start', 'important');
        break;
      }

      root.querySelectorAll('[data-ur-moved="1"]').forEach(function (el) {
        el.style.setProperty('display', 'flex', 'important');
        el.style.setProperty('flex-direction', 'column', 'important');
        el.style.setProperty('align-items', 'flex-start', 'important');
      });

      root.querySelectorAll('[class*="accordion"]').forEach(function (el) {
        el.style.setProperty('border', 'none', 'important');
        el.style.setProperty('border-top', 'none', 'important');
        el.style.setProperty('border-bottom', 'none', 'important');
        el.style.setProperty('outline', 'none', 'important');
      });

      root.querySelectorAll('.active-subscription__extended > *, .active-subscription__extended > * > *').forEach(function (el) {
        el.style.setProperty('border', 'none', 'important');
        el.style.setProperty('border-top', 'none', 'important');
        el.style.setProperty('border-bottom', 'none', 'important');
      });

      var germanMonths = { 'Januar':'01','Februar':'02','März':'03','April':'04','Mai':'05','Juni':'06','Juli':'07','August':'08','September':'09','Oktober':'10','November':'11','Dezember':'12' };
      root.querySelectorAll('.bsub-data-table td').forEach(function (cell) {
        if (cell.getAttribute('data-ur-date')) return;
        var text = cell.textContent.trim();
        var m = text.match(/^(\d+)\.\s+(\w+)\s+(\d{4})\s+um\s+(\d+:\d+)/);
        if (!m) return;
        var month = germanMonths[m[2]];
        if (!month) return;
        cell.textContent = m[1].padStart(2, '0') + '.' + month + '.' + m[3] + ' ' + m[4];
        cell.setAttribute('data-ur-date', '1');
      });

      root.querySelectorAll('.bsub-highlighted-header').forEach(function (header) {
        var t = header.textContent.trim();
        if (t !== 'BESTELLDATUM' && t !== 'Order date' && t !== 'ORDER DATE') return;

        var entry = header.parentElement && header.parentElement.parentElement;
        if (!entry || entry === root || entry.getAttribute('data-ur-tile')) return;
        entry.setAttribute('data-ur-tile', '1');
      });

      var buttonMap = {
        'SAVE': 'Speichern',
        'Save': 'Speichern',
        'SAVE CHANGES': 'Änderungen speichern',
        'Save changes': 'Änderungen speichern',
        'CANCEL': 'Abbrechen',
        'Cancel': 'Abbrechen',
        'REMOVE DISCOUNT': 'Rabatt entfernen',
        'Remove discount': 'Rabatt entfernen',
        'ADD PRODUCTS': 'Produkte hinzufügen',
        'Add products': 'Produkte hinzufügen',
        'ORDER NOW': 'Jetzt bestellen',
        'Order now': 'Jetzt bestellen',
      };
      root.querySelectorAll('button').forEach(function (btn) {
        var t = btn.textContent.trim();
        if (buttonMap[t]) {
          var walker = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT, null, false);
          var node;
          while ((node = walker.nextNode())) {
            if (node.nodeValue.trim() === t) {
              node.nodeValue = buttonMap[t];
            }
          }
        }
      });
    });
  }

  if (window.location.pathname.indexOf('manage-subscription') === -1) return;

  var observer = new MutationObserver(applyReplacements);

  document.addEventListener('DOMContentLoaded', function () {
    applyReplacements();
    setTimeout(applyReplacements, 500);
    setTimeout(applyReplacements, 1500);
    setTimeout(applyReplacements, 3000);
    setTimeout(applyReplacements, 5000);
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
